import {
  fetchResponseWithToken,
  getApigeeUrl,
} from '@adsk/acs-sc-web-platform-api';

import { FolderUtil } from './formatEntities';
import Services, { FileUtil, SortingUtil } from './sdkServices';
import { isRfiSource } from './uploadHelper';

export const getThumbnail = async (
  bubbleUrn,
  bubbleViewableGuid,
  scopes,
  options = { width: 128, height: 96 },
) => {
  try {
    const path = await Services.DerivativeService.getThumbnailByUrn(
      bubbleUrn,
      {
        ...options,
        scopes,
        guid: bubbleViewableGuid,
      },
      { skipBlob: true },
    );
    const res = await fetchResponseWithToken(`${getApigeeUrl()}${path}`);
    if (res.status !== 200) return undefined;
    const blob = await res.blob();
    return URL.createObjectURL(blob);
  } catch {
    return undefined;
  }
};

export const chunk = (arr, size) => {
  const output = [];
  for (let i = 0; i < arr.length; i += size) {
    output.push(arr.slice(i, i + size));
  }
  return output;
};

export const differenceBy = (arr1, arr2, key) => {
  const set = new Set(arr2.map((item) => item[key]));
  return arr1.filter((item) => !set.has(item[key]));
};

export const uniq = (arr) => {
  const set = new Set(arr);
  return [...set];
};

export const getDistributedAndSortedFolders = (folders) => {
  const sortedFolders = [...folders].sort((a, b) =>
    SortingUtil.naturalCompare(a, b, 'title'),
  );
  const distributedFolderIndex = sortedFolders.findIndex(
    FolderUtil.isSharedFolder,
  );
  let distributedFolder = [];
  let remainingFolders = sortedFolders;
  if (distributedFolderIndex > -1) {
    distributedFolder = [sortedFolders[distributedFolderIndex]];
    remainingFolders = [
      ...sortedFolders.slice(0, distributedFolderIndex),
      ...sortedFolders.slice(distributedFolderIndex + 1),
    ];
  }

  return [...distributedFolder, ...remainingFolders];
};

export const isVirtualFolder = (folder) =>
  folder?.folderType === 'container_virtual';

export const isRfiUpload = (sourceEntityType, entity) => {
  // Cached file, RFI upload from UploadPanel
  if (entity.isRfiUpload) return true;

  // Selected file, RFI pick from DocsCustomDataView
  return isRfiSource(sourceEntityType) && isVirtualFolder(entity.parentFolder);
};

export const isMalwareDetected = (entity) =>
  Boolean(entity.version?.malwareDetected);

export const isDynamicView = (entity) => FileUtil.isDynamicView(entity);
